// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";

function reducer(count, action) {
  if (action) {
    return count + 1 | 0;
  } else {
    return 0;
  }
}

function CounterPage(Props) {
  var match = React.useReducer(reducer, 0);
  var dispatch = match[1];
  return React.createElement("div", undefined, React.createElement("h1", undefined, "Hello from Reason"), React.createElement("div", undefined, "Counter"), React.createElement("div", undefined, String(match[0])), React.createElement("button", {
                  onClick: (function (_e) {
                      return Curry._1(dispatch, /* Reset */0);
                    })
                }, "Reset"), React.createElement("button", {
                  onClick: (function (_e) {
                      return Curry._1(dispatch, /* Increment */1);
                    })
                }, "Increment"));
}

var initialState = 0;

var make = CounterPage;

export {
  initialState ,
  reducer ,
  make ,
  
}
/* react Not a pure module */
